module.exports = __webpack_public_path__ + "static/media/logos.512781f4.jpg";